<template>
  <!-- mirror-block: a gravação do espelho pula esta camada (senão o desenho voltava pro supervisor duplicado). -->
  <canvas v-show="!mirrorMarksHidden" ref="canvasRef" class="smm mirror-block" aria-hidden="true"></canvas>
</template>

<script setup lang="ts">
// Marcações do Espelho ao vivo na tela do AGENTE: o que o supervisor desenha (lápis, seta, texto, ponteiro) aparece
// por cima do WootDash, sem pegar clique. Trocou de página ou redimensionou a janela: as marcações somem (perderam o
// lugar) e o supervisor é avisado. O agente pode esconder pelo aviso do espelho (ScreenMirrorIndicator).
import { ref, watch, onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { drawMarks, fitCanvas } from '@/utils/mirrorMarks'
import { mirrorBoard, marksVersion, mirrorMarksHidden, clearMirrorMarks } from '@/composables/useScreenMirror'

const canvasRef = ref<HTMLCanvasElement | null>(null)
const router = useRouter()
let frame = 0

function paint() {
  frame = 0
  const canvas = canvasRef.value
  if (!canvas) return
  const before = mirrorBoard.marks.size
  const animating = mirrorBoard.prune()
  // Lápis/seta venceu e sumiu: avisa quem depende da contagem (o aviso do espelho).
  if (mirrorBoard.marks.size !== before) marksVersion.value++
  const ctx = fitCanvas(canvas, window.innerWidth, window.innerHeight)
  if (ctx) drawMarks(ctx, window.innerWidth, window.innerHeight, mirrorBoard)
  // Lápis/seta esmaecendo ou ponteiro: continua animando; só texto parado não precisa.
  if (animating) frame = requestAnimationFrame(paint)
}

function schedule() {
  if (!frame) frame = requestAnimationFrame(paint)
}

watch(marksVersion, schedule)

let resizeTimer: ReturnType<typeof setTimeout> | undefined
function onResize() {
  if (resizeTimer) clearTimeout(resizeTimer)
  resizeTimer = setTimeout(() => { clearMirrorMarks(); schedule() }, 200)
}

const offRoute = router.afterEach((to, from) => {
  if (to.fullPath !== from.fullPath) clearMirrorMarks()
})

onMounted(() => {
  window.addEventListener('resize', onResize)
  schedule()
})
onUnmounted(() => {
  window.removeEventListener('resize', onResize)
  offRoute()
  if (frame) cancelAnimationFrame(frame)
  if (resizeTimer) clearTimeout(resizeTimer)
})
</script>

<style scoped>
.smm { position: fixed; inset: 0; width: 100vw; height: 100vh; z-index: 9400; pointer-events: none; }
</style>
